import { Banner, Text } from '@betterment/samba-react';

type DownloadErrorBannerProps = {
  resource: 'download' | 'statement';
};

export const DownloadErrorBanner: React.FC<DownloadErrorBannerProps> = ({ resource }) => (
  <Banner variant="warning" css={{ mt: 'space.200' }}>
    <Banner.Content>
      <Text as="p">There was an issue with your {resource}. Please try again later.</Text>
    </Banner.Content>
  </Banner>
);
